import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import TransactionForm from 'components/app/bookings/car/transaction/TransactionForm';

// Route-level page for New / Edit car booking.
const CarBookingFormPage = ({ mode }) => {
  const location = useLocation();

  if (mode === 'edit') {
    return <TransactionForm title="Edit car booking" transaction={location.state} />;
  }

  const { travel } = location.state || {};
  return <TransactionForm title="Request car booking" travel={travel} />;
};

CarBookingFormPage.propTypes = {
  mode: PropTypes.oneOf(['new', 'edit']),
};

CarBookingFormPage.defaultProps = {
  mode: 'new',
};

export default CarBookingFormPage;
